import { StyleSheet } from 'react-native';

import { Fonts } from 'assets/fonts';

import { lightGrey } from 'utils/colors';
import {
    heightPercentageToDP,
    isTabletOrWeb,
    widthPercentageToDP,
} from 'utils/responsiveness';

const styles = StyleSheet.create({
    container: {
        width: widthPercentageToDP(321, 400, 520),
        marginBottom: heightPercentageToDP(8, 16, 16),
        alignSelf: isTabletOrWeb ? 'flex-start' : 'center',
    },
    title: {
        fontFamily: Fonts.main.bold,
        fontSize: 32,
        lineHeight: 40,
        color: lightGrey(),
        textAlign: isTabletOrWeb ? 'left' : 'center',
    },
});

export default styles;
